import {
  Avatar,
  Box,
  Checkbox,
  CircularProgress,
  Divider,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import useConfig from "../../../../hooks/useConfig";
import axios from "../../../../utils/axios";
import { APIRoutes } from "../../../../utils/constants";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import { UserContext } from "../..";
import { toast } from "react-toastify";
import EllipsisContent from "../../../../Common/Component/EllipsisContent";
import HttpService from "../../../../hooks/Https-services";
import { useParams } from "react-router-dom";

const TeamCards = () => {
  const [isChecked, setIsChecked] = useState(-1);
  const {
    selectedTeam,
    setSelectedTeam,
    selectAllTeamPlayers,
    setSelectAllTeamPlayers,
    selectedPlayer,
    channelData,
    selectedEvent,
    channel,
    selectedSeason,
  }: any = useContext(UserContext);
  const [teamsData, setTeamsData] = useState([]);
  const [searchTeam, setSearchTeam] = useState("");
  const [isSkeleton, setIsSkeleton] = useState(true);

  // const handleCheckboxClick = () => {
  //   setIsChecked(!isChecked);
  // };
  const configData = useConfig();
  const { channel_id }: any = useParams();

  const updateChannel = async (teams: any, allTeams: any) => {
    const updateConfigure = {
      Name: channelData,
      Teams: teams,
      Players: selectedPlayer,
      Events: selectedEvent,
      All: allTeams,
      Seasons: selectedSeason,
    };

    try {
      const res = await HttpService.post(
        APIRoutes.UpdateChannel.replace(":id", channel_id),
        {
          configure: updateConfigure,
        }
      );
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };
  const GetAllTeams = async () => {
    try {
      const res = await HttpService.getS(APIRoutes.GetAllTeamsHTP);
      if (res) {
        const data = res?.data?.data?.map((el: any) => el);
        setTeamsData(data);
        setIsSkeleton(false);
      }
      setIsSkeleton(false);
    } catch (error) {
      setIsSkeleton(false);
    }
  };

  useEffect(() => {
    GetAllTeams();
  }, []);

  return (
    <>
      <Box sx={{ my: 1, width: 1 }}>
        <TextField
          placeholder="Search Teams"
          size="small"
          fullWidth
          onChange={(e: any) => setSearchTeam(e.target.value)}
        />
      </Box>
      {isSkeleton ? (
        <Box
          sx={{ display: "flex", justifyContent: "center", py: 10, width: 1 }}
        >
          <CircularProgress
            size={48}
            sx={{
              color: "#bf311a",
            }}
          />
        </Box>
      ) : teamsData?.length != 0 ? (
        <Box sx={{ display: "flex", flexDirection: "column", width: 1 }}>
          {teamsData
            ?.filter((el: any) => {
              if (searchTeam) {
                return el?.team_name
                  ?.toLowerCase()
                  .includes(searchTeam.toLowerCase());
              } else {
                return el;
              }
            })
            .map((teamData: any, index: any) => (
              <Box sx={{ borderBottom: "1px solid #dadada" }} key={index + 1}>
                <Box
                  sx={{
                    padding: 1,
                    textAlign: "center",
                    position: "relative",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    maxHeight: "100px",
                  }}
                >
                  <EllipsisContent text={teamData?.team_name} />
                  <Checkbox
                    onChange={(e) => {
                      if (e.target.checked) {
                        const filterTeamIds = selectedTeam.filter((el: any) =>
                          selectAllTeamPlayers.includes(el)
                        );
                        updateChannel(
                          [...selectedTeam, teamData?.team_id],
                          Array.from(
                            new Set([...filterTeamIds, teamData?.team_id])
                          )
                        );

                        setSelectAllTeamPlayers(
                          Array.from(
                            new Set([...filterTeamIds, teamData?.team_id])
                          )
                        );
                        setSelectedTeam([...selectedTeam, teamData?.team_id]);
                      } else {
                        const index = selectedTeam.findIndex(
                          (element: any) => element == teamData?.team_id
                        );
                        if (index != -1) {
                          const teamData2 = selectedTeam.filter(
                            (e: any, ind: any) => ind != index
                          );

                          setSelectedTeam(teamData2);
                          const filterOutAllTeamData =
                            selectAllTeamPlayers?.filter(
                              (el: any) => el != teamData?.team_id
                            );
                          updateChannel(teamData2, filterOutAllTeamData);

                          setSelectAllTeamPlayers(filterOutAllTeamData);
                        }
                      }
                    }}
                    disabled={
                      selectedTeam?.length == 3 &&
                      !selectedTeam.includes(teamData?.team_id)
                    }
                    checked={
                      selectedTeam?.includes(teamData?.team_id) ? true : false
                    }
                  />
                </Box>
              </Box>
            ))}
        </Box>
      ) : (
        <Typography sx={{ my: 2, mx: "auto" }}>No data found</Typography>
      )}
    </>
  );
};

export default TeamCards;
